import imageDe from '../images/de/kanta_approval.png';
import imageEn from '../images/en/kanta_approval.png';
import imageEs from '../images/es/kanta_approval.png';
import imageFi from '../images/fi/kanta_approval.png';
import imageFr from '../images/fr/kanta_approval.png';
import imageIt from '../images/it/kanta_approval.png';
import imageNo from '../images/no/kanta_approval.png';
import imageSv from '../images/sv/kanta_approval.png';

export const kantaApprovalImage = {
  de() {
    return imageDe;
  },
  en() {
    return imageEn;
  },
  es() {
    return imageEs;
  },
  fi() {
    return imageFi;
  },
  fr() {
    return imageFr;
  },
  it() {
    return imageIt;
  },
  no() {
    return imageNo;
  },
  sv() {
    return imageSv;
  },
};
